/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { CardGrid } from '@entrata/portals-common/lib/components'
import ProductGridItem from './ProductGridItem'

const ProductGrid = ({ children, isHomePage }) => (
  <CardGrid columns={isHomePage ? 3 : 2} gutter={16} minColSize='320px'>
    {children}
  </CardGrid>
)

ProductGrid.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
}

export default ProductGrid
